import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["scopeBlock"];

  connect() {
    this.syncVisibility = this.syncVisibility.bind(this);
    this.element.addEventListener("change", this.syncVisibility);
    if (this.rolePillsContainer) {
      this.rolePillsContainer.addEventListener("click", () => {
        requestAnimationFrame(this.syncVisibility);
      });
    }
    this.syncVisibility();
  }

  disconnect() {
    this.element.removeEventListener("change", this.syncVisibility);
  }

  update() {
    this.syncVisibility();
  }

  syncVisibility() {
    const roleSelected = this.roleCheckboxes.some((checkbox) => checkbox.checked);
    this.scopeBlockTarget.classList.toggle("d-none", !roleSelected);

    if (!roleSelected) {
      this.clearScopeFilters();
    }
  }

  clearScopeFilters() {
    this.scopeBaseCheckboxes.forEach((checkbox) => {
      checkbox.checked = false;
    });

    const allBasesCheckbox = this.allBasesCheckbox;
    if (!allBasesCheckbox) return;

    allBasesCheckbox.checked = false;
    const pill = allBasesCheckbox.closest(".cred-role-pill");
    if (pill) {
      pill.classList.remove("cred-role-pill--active");
    }
  }

  get rolePillsContainer() {
    return this.element.querySelector(".cred-role-pills");
  }

  get roleCheckboxes() {
    return Array.from(
      this.element.querySelectorAll(
        'input[name="credentialing_search[mentor_role_type_ids][]"]'
      )
    );
  }

  get scopeBaseCheckboxes() {
    return Array.from(
      this.element.querySelectorAll(
        'input[name="credentialing_search[mentor_scope_base_ids][]"]'
      )
    );
  }

  get allBasesCheckbox() {
    return this.element.querySelector(
      'input[name="credentialing_search[mentor_scope_all]"][value="1"]'
    );
  }
}
